import {CheckBox} from 'devextreme-react/check-box';
import {useContext} from 'react';
import {Field, Panel} from '../../../../layouts';
import {MaterialOrderContext} from '../context/MaterialOrderContext';

export default function CFIInformationPanel() {

	const { order } = useContext(MaterialOrderContext);

	return (
		<>
			<Panel
				header={'CFI Information'}
			>
				<Field label={'CFI PO Number'} >{order.details.COMPONumber}</Field>
				<Field label={'Ship To Location'} >{order.details.shipToLocation}</Field>
				<Field label={'Will Call'} >
					<CheckBox value={order.details.willCall} readOnly={true}></CheckBox>
				</Field>
			</Panel>
		</>
	);
}
